<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">شرح وظایف</h4>
    </div>
    <div class="card-body">
      <div class="duty-row mb-3">
        <div>
          <label class="form-label fw-bold">شرح وظیفه</label>
          <input
              type="text"
              class="form-control"
              placeholder="شرح وظیفه را وارد کنید"
              v-model="newItem.description"
          />
        </div>
        <div>
          <label class="form-label fw-bold">نوع فعالیت</label>
          <select class="form-select" v-model="newItem.activity_type">
            <option value="" disabled>انتخاب نوع فعالیت</option>
            <option v-for="(activity, index) in activityTypes" :key="index" :value="activity">
              {{ activity }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">فراوانی تکرار</label>
          <select class="form-select" v-model="newItem.repetition_frequency">
            <option value="" disabled>انتخاب فراوانی تکرار</option>
            <option v-for="(frequency, index) in repetitionFrequencies" :key="index" :value="frequency">
              {{ frequency }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">میزان اهمیت</label>
          <select class="form-select" v-model="newItem.importance">
            <option value="" disabled>انتخاب میزان اهمیت</option>
            <option v-for="(importance, index) in importanceLevels" :key="index" :value="importance">
              {{ importance }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">سختی یادگیری</label>
          <select class="form-select" v-model="newItem.difficulty_learning">
            <option value="" disabled>انتخاب سختی یادگیری</option>
            <option v-for="(difficulty, index) in difficultyLevels" :key="index" :value="difficulty">
              {{ difficulty }}
            </option>
          </select>
        </div>
        <div>
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['شرح وظیفه', 'نوع فعالیت', 'فراوانی تکرار', 'میزان اهمیت', 'سختی یادگیری']"
          :fields="['description', 'activity_type', 'repetition_frequency', 'importance', 'difficulty_learning']"
          :items="dutiesDescription"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          :title="'ویرایش وظیفه'"
          modal-id="dutyModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-12 mb-3">
            <label class="form-label fw-bold">شرح وظیفه</label>
            <input
                type="text"
                class="form-control"
                placeholder="شرح وظیفه را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.description"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label fw-bold">نوع فعالیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.activity_type">
              <option value="" disabled>نوع فعالیت را انتخاب کنید</option>
              <option v-for="(activity, index) in activityTypes" :key="index" :value="activity">
                {{ activity }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">فراوانی تکرار</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.repetition_frequency">
              <option value="" disabled>فراوانی تکرار را انتخاب کنید</option>
              <option v-for="(frequency, index) in repetitionFrequencies" :key="index" :value="frequency">
                {{ frequency }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label fw-bold">میزان اهمیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.importance">
              <option value="" disabled>میزان اهمیت را انتخاب کنید</option>
              <option v-for="(importance, index) in importanceLevels" :key="index" :value="importance">
                {{ importance }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">دشواری یادگیری</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.difficulty_learning">
              <option value="" disabled>سختی یادگیری را انتخاب کنید</option>
              <option v-for="(difficulty, index) in difficultyLevels" :key="index" :value="difficulty">
                {{ difficulty }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  description: '',
  activity_type: '...',
  repetition_frequency: '...',
  importance: '',
  difficulty_learning: ''
};
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/duties-description/index',
      afterMutation: 'dutiesDescription/setDutiesDescription'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      activityTypes: ['...', 'جاری', 'موردی'],
      repetitionFrequencies: ['...', 'ماهانه', 'سه ماهه', 'شش ماهه', 'سالانه'],
      importanceLevels: ['خیلی زیاد', 'زیاد', 'متوسط', 'کم', 'خیلی کم'],
      difficultyLevels: ['خیلی زیاد', 'زیاد', 'متوسط', 'کم', 'خیلی کم'],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    dutiesDescription: {
      get() {
        return this.$store.state.dutiesDescription.dutiesDescription;
      },
      set(value) {
        this.$store.commit('dutiesDescription/setDutiesDescription', value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/duties-description/store',
      })

      this.dutiesDescription = [...this.dutiesDescription, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeItem(index) {
      const dutyDescription = this.dutiesDescription.find((_, i) => i === index);
      this.dutiesDescription = this.dutiesDescription.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: dutyDescription.id,
        endpoint: '/duties-description/delete',
      })
    },
    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('dutyModalId'));
      modal.show();
    },
    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.dutiesDescription.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/duties-description/update',
      })

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('dutyModalId'));
      modal.hide();
    },
    checkItemValidation(item) {
      if (
          !item.description ||
          !item.importance ||
          !item.difficulty_learning
      ) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    },
  }
};
</script>
